<div #benefitsContainer class="max-w-[425px] mx-auto lg:m-0 lg:w-[340px] h-[85vh] lg:h-auto lg:max-h-[calc(100vh-80px)] overflow-y-auto overflow-x-hidden no-scrollbar flex flex-col gap-y-3 relative lg:bg-black rounded-3xl p-2.5" [class]="{'hidden': hideElement}">

    @for (ams of amenities(); track $index) {
        
        <ng-container>
            
            <app-menu-card
                [title]="ams.name"
                [image]="ams.assets?.[0]?.urlSigned"
                [active]="amenity() === amenities()[$index]"
                (itemClicked)="toggleAmenity($index)"
            />

            @if (amenity() === amenities()[$index]) {
                    
                <div 
                    class="flex flex-col gap-y-3 transition origin-top" 
                    [class]="amenity() ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-0 pointer-events-none'"
                >

                    @if(descriptions()){
                        <app-benefits-descriptions 
                            [descriptions]="descriptions()!"
                        />
                    } 

                    @if(contact()){
                        <app-benefits-contact
                            [email]="contact()?.emailAddress1!"
                            [phone]="contact()?.phoneNumber1!"
                        />
                    }
                      
                    @if(carouselData()){
                        <app-benefits-carousel
                            [title]="ams.title" 
                            [data]="carouselData()!"
                        />
                    }



                    
                </div>  

            }
            
            
        </ng-container>

    }

</div>